// import useDemoConfig from "./useDemoConfig";
import React from "react";
import { AxisOptions, Chart, UserSerie } from "react-charts";
import classes from "./styles.module.css";
import { BarData } from "../../../types";

interface BarProps {
    className?: string;
    data?: UserSerie<BarData>[];
}

const Bar = ({ className = "", data = [] }: BarProps) => {
    // data = useDemoConfig({
    //     series: 3,
    //     dataType: "ordinal",
    // }).data;

    // console.log(data);

    const primaryAxis = React.useMemo<AxisOptions<BarData>>(
        () => ({
            position: "left",
            getValue: (datum) => datum.primary,
        }),
        []
    );

    const secondaryAxes = React.useMemo<AxisOptions<BarData>[]>(
        () => [
            {
                position: "bottom",
                getValue: (datum) => datum.secondary,
                max: 100, // Set the maximum value for the x-axis
                min: 0,
            },
        ],
        []
    );

    return (
        <div className={`${classes.root} ${className}`}>
            {data.length > 0 && (
                <Chart
                    options={{
                        data,
                        primaryAxis,
                        secondaryAxes,
                    }}
                />
            )}
        </div>
    );
};

export default Bar;
